// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.teamsScreen {
  width: 100%;
  min-width: 0;
}
.teamsPage__list {
  width: 100%;
  min-height: 100%;
  margin: 0;
  padding-bottom: 32px;
  color: #334155;
  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);
}
.teamsPage__header {
  display: flex;
  width: calc(100% + 48px);
  min-height: 70px;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin: -20px 0 18px -24px;
  padding: 0 72px 0 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}
.teamsPage__headerTitle {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
}
.teamsPage__header h1 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', var(--font-body, 'Public Sans', system-ui, sans-serif));
  font-size: 22px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.015em;
}
.teamsPage__headerTitle > span {
  display: inline-flex;
  min-width: 24px;
  height: 22px;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 11.5px;
  font-weight: 800;
}
.teamsBtn {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #fff;
  color: #334155;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: border-color 0.14s ease, background-color 0.14s ease, color 0.14s ease, box-shadow 0.14s ease;
}
.teamsBtn--primary {
  border-color: #227ebd;
  background: #227ebd;
  color: #fff;
}
.teamsBtn--primary:hover:not(:disabled) {
  border-color: var(--blue-600, #1a6da3);
  background: var(--blue-600, #1a6da3);
}
.teamsBtn:focus-visible,
.teamsPage__list button:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.16);
}
.teamsBtn--danger {
  border-color: transparent;
  background: var(--red-500, #da4453);
  color: #fff;
}
.teamsBtn--danger:hover:not(:disabled) {
  background: var(--red-600, #c4313f);
  box-shadow: 0 4px 12px rgba(218, 68, 83, 0.28);
}
.teamsBtn.is-active {
  border-color: #227ebd;
  background: #eef7fd;
  color: #155d8c;
}
.teamsPage__toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 64px;
  padding: 11px 16px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}
.teamsPage__search {
  position: relative;
  display: block;
  width: min(340px, 100%);
  margin-bottom: 0;
}
.teamsPage__search input {
  width: 100%;
  height: var(--control-h-md, 40px);
  min-width: 0;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  outline: none;
  background: var(--surface-card, #fff);
  color: var(--text-strong, #0f172a);
  padding: 0 38px 0 12px;
  font-size: var(--text-md, 14px);
  box-shadow: none;
}
.teamsPage__search > button {
  position: absolute;
  top: 50%;
  right: 7px;
  display: inline-flex;
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--text-muted, #64748b);
  font: inherit;
  font-size: 18px;
  transform: translateY(-50%);
  cursor: pointer;
}
.teamsPage__search > button:hover {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-strong, #0f172a);
}
.teamsPage__search input:focus {
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));
}
.teamsPage__columns {
  position: relative;
  display: flex;
}
.teamsPage__filterBtn,
.teamsPage__columnsBtn {
  position: relative;
  display: inline-flex;
  height: 40px;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #334155;
  cursor: pointer;
}
.teamsPage__filterBtn {
  width: auto;
  gap: 8px;
  padding: 0 12px;
  font-size: 13px;
  font-weight: 700;
}
.teamsPage__columnsBtn {
  gap: 8px;
  padding: 0 12px 0 11px;
  font-size: 13px;
  font-weight: 700;
}
.teamsPage__filterBtn:hover,
.teamsPage__filterBtn.is-active,
.teamsPage__columnsBtn:hover,
.teamsPage__columnsBtn.is-active {
  border-color: #6fb1df;
  background: #eef7fd;
  color: #155d8c;
}
.teamsPage__toolbarIcon {
  display: inline-block;
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  background: currentColor;
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: 16px 16px;
  -webkit-mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: 16px 16px;
}
.teamsPage__toolbarIcon--filter {
  mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E");
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E");
}
.teamsPage__toolbarIcon--columns {
  mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='5' width='16' height='14' rx='2' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='M9 5v14M15 5v14' stroke='black' stroke-width='2'/%3E%3C/svg%3E");
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='5' width='16' height='14' rx='2' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='M9 5v14M15 5v14' stroke='black' stroke-width='2'/%3E%3C/svg%3E");
}
.teamsPage__filterDot {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 7px;
  height: 7px;
  border: 1.5px solid #fff;
  border-radius: 50%;
  background: #f08c1a;
}
.teamsPage__filterBadge {
  display: inline-flex;
  min-width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border-radius: 999px;
  background: #227ebd;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
}
.teamsPage__columnsBadge {
  display: inline-flex;
  min-width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  border-radius: 999px;
  background: #eef6fc;
  color: #155d8c;
  font-size: 11px;
}
.teamsPage__columnsMenu {
  position: absolute;
  z-index: 20;
  top: 46px;
  right: 0;
  display: grid;
  width: 190px;
  gap: 10px;
  padding: 14px;
  border: 1px solid #dbe3ec;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.14);
}
.teamsPage__columnsMenu strong {
  color: #142033;
  font-size: 13px;
}
.teamsPage__columnsMenu label {
  display: flex;
  align-items: center;
  gap: 9px;
  color: #475569;
  font-size: 13px;
}
.teamsPage__filters {
  position: fixed;
  z-index: 1050;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  width: 360px;
  max-width: calc(100vw - 20px);
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  padding: 18px 18px 86px;
  overflow-y: auto;
  border: 0;
  border-left: 1px solid #d9e2ec;
  border-radius: 0;
  background: #fff;
  box-shadow: -12px 0 34px rgba(15, 23, 42, 0.14);
}
.teamsPage__filters label {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 6px;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}
.teamsPage__filters select {
  height: 40px;
  padding: 7px;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #fff;
  color: #334155;
}
.teamsPage__sportFilterControl {
  position: relative;
}
.teamsPage__sportFilterControl > input {
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  padding: 0 38px 0 11px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 9px;
  background: #fff;
  color: var(--text-body, #334155);
  font: inherit;
  font-size: 13px;
  font-weight: 500;
}
.teamsPage__sportFilterControl > input:focus {
  border-color: var(--action-primary, #227ebd);
  outline: 0;
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.13);
}
.teamsPage__sportFilterControl > button {
  position: absolute;
  z-index: 2;
  top: 5px;
  right: 5px;
  width: 30px;
  height: 30px;
  padding: 0;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--text-muted, #64748b);
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}
.teamsPage__sportFilterControl > button:hover {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-strong, #0f172a);
}
.teamsPage__sportFilterOptions {
  position: absolute;
  z-index: 6;
  top: calc(100% + 5px);
  right: 0;
  left: 0;
  display: grid;
  max-height: 224px;
  padding: 5px;
  overflow-y: auto;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 9px;
  background: #fff;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.14);
}
.teamsPage__sportFilterOptions > button {
  padding: 9px 10px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--text-body, #334155);
  font: inherit;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
}
.teamsPage__sportFilterOptions > button:hover,
.teamsPage__sportFilterOptions > button[aria-selected='true'] {
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}
.teamsPage__sportFilterOptions > span {
  padding: 10px;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  font-weight: 500;
}
.teamsPage__filtersHeader {
  display: flex;
  min-height: 34px;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid #e6ebf1;
}
.teamsPage__filtersHeader > div {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.teamsPage__filtersHeader strong {
  color: #172b4d;
  font-size: 16px;
  font-weight: 800;
}
.teamsPage__filtersHeader span {
  color: #64748b;
  font-size: 12px;
}
.teamsPage__filtersHeader > button {
  width: 30px;
  height: 30px;
  padding: 0;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #667085;
  font-size: 22px;
  cursor: pointer;
}
.teamsPage__squad {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #475569;
}
.teamsPage__more {
  width: 34px;
  height: 34px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: var(--text-subtle, #94a3b8);
  font: inherit;
  font-size: 23px;
  line-height: 1;
  opacity: 0;
  cursor: pointer;
  transition: opacity 0.14s ease, border-color 0.14s ease, background-color 0.14s ease, color 0.14s ease;
}
.teamsPage__more:hover {
  border-color: #dbe3ec;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-body, #334155);
}
.teamsPage__table tbody tr:hover .teamsPage__more,
.teamsPage__more:focus-visible {
  opacity: 1;
}
.teamsDrawer__scrim {
  position: fixed;
  z-index: 1090;
  inset: 0;
  border: 0;
  background: rgba(15, 23, 42, 0.35);
}
.teamsDrawer {
  position: fixed;
  z-index: 1100;
  top: 0;
  right: 0;
  display: flex;
  width: min(480px, 100vw);
  height: 100vh;
  flex-direction: column;
  background: #fff;
  box-shadow: -18px 0 48px rgba(15, 23, 42, 0.18);
  color: #334155;
  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);
}
.teamsDrawer__head {
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 22px 20px 18px;
  border-bottom: 1px solid #e5eaf0;
}
.teamsDrawer__lead {
  display: flex;
  width: 46px;
  height: 46px;
  flex: 0 0 46px;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #eaf4fb;
  color: #227ebd;
  font-size: 21px;
}
.teamsDrawer__head > div {
  min-width: 0;
}
.teamsDrawer__head h2 {
  margin: 0;
  overflow: hidden;
  color: #142033;
  font-size: 19px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.teamsDrawer__head p {
  margin: 4px 0 0;
  color: #69778a;
  font-size: 12px;
}
.teamsDrawer__close {
  width: 36px;
  height: 36px;
  margin-left: auto;
  border: 0;
  border-radius: 9px;
  background: #f1f5f9;
  color: #526174;
  font-size: 23px;
}
.teamsDrawer__tabs {
  display: flex;
  padding: 0 20px;
  border-bottom: 1px solid #e5eaf0;
}
.teamsDrawer__tabs button {
  min-height: 46px;
  padding: 0 13px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: #69778a;
  font-family: inherit;
  font-size: 13.5px;
  font-weight: 650;
}
.teamsDrawer__tabs button.is-active {
  border-bottom-color: #227ebd;
  color: #155d8c;
}
.teamsDrawer__tabs span {
  margin-left: 6px;
  padding: 1px 6px;
  border-radius: 999px;
  background: #eef2f6;
  font-size: 10px;
}
.teamsDrawer__body {
  min-height: 0;
  flex: 1;
  overflow: auto;
  padding: 20px;
  font-family: inherit;
  font-size: 13.5px;
  line-height: 1.45;
}
.teamsDrawer__body .container-fluid {
  padding: 0;
}
.teamsDrawer__foot {
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  padding: 14px 20px;
  border-top: 1px solid #e5eaf0;
  background: #fff;
}
.teamsDrawer__foot button {
  min-width: max-content;
  font-family: inherit;
  white-space: nowrap;
}
.teamsPage__filters > .teamsPage__filtersActions {
  position: fixed;
  z-index: 2;
  right: 0;
  bottom: 0;
  display: flex;
  width: 360px;
  max-width: calc(100vw - 20px);
  justify-content: space-between;
  gap: 8px;
  margin: 0;
  padding: 14px 18px;
  border-top: 1px solid #e6ebf1;
  background: #fff;
}
.teamsPage__filtersActions > div {
  display: flex;
  gap: 8px;
}
.teamsPage__filtersActions .is-clear {
  border-color: transparent;
  background: transparent;
  color: var(--text-muted, #64748b);
}
.teamsPage__filtersActions .is-clear:hover {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-strong, #0f172a);
}
.teamsPage__filterChips {
  display: flex;
  min-height: 43px;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 8px 16px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}
.teamsPage__filterChips > span {
  display: inline-flex;
  min-height: 27px;
  align-items: center;
  gap: 4px;
  padding: 0 8px;
  border-radius: 999px;
  background: #eaf4fb;
  color: #155d8c;
  font-size: 12px;
}
.teamsPage__filterChips > span button,
.teamsPage__filterChipsClear {
  padding: 0;
  border: 0;
  background: transparent;
  color: #1a6da3;
  cursor: pointer;
  font-weight: 700;
}
.teamsPage__filterChipsClear:hover {
  text-decoration: underline;
}
.teamsPage__selection {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 10px 16px;
  border-bottom: 1px solid #b9d9ee;
  background: var(--blue-50, #eef6fc);
  color: #155d8c;
  font-size: 13px;
  font-weight: 700;
}
.teamsPage__selection > div {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  margin-left: 12px;
}
.teamsPage__clear {
  margin-left: auto;
  border: 0;
  background: none;
  color: #526174;
  font-size: 12px;
  text-decoration: underline;
}
.teamsDelete {
  color: #334155;
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}
.teamsDelete__alert {
  display: flex;
  gap: 14px;
  padding: 16px;
  border: 1px solid #fecdd3;
  border-radius: 12px;
  background: #fff1f2;
}
.teamsDelete__icon {
  display: inline-flex;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #ffe4e6;
  color: #be123c;
  font-size: 20px;
  font-weight: 800;
}
.teamsDelete h3 {
  margin: 0 0 4px;
  color: #881337;
  font-size: 15px;
  font-weight: 800;
}
.teamsDelete p {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
}
.teamsDelete__details {
  padding: 16px 2px;
}
.teamsDelete__names {
  margin-top: 8px !important;
  color: #64748b;
}
.teamsDelete__confirm {
  display: flex;
  margin: 0;
  flex-direction: column;
  gap: 7px;
  font-size: 13px;
}
.teamsDelete__confirm input {
  height: 40px;
  padding: 0 11px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font: inherit;
}
.teamsDelete__confirm input:focus {
  border-color: #6fb1df;
  outline: 0;
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.12);
}
.teamsDelete__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
}
.teamsDelete__cancel,
.teamsDelete__submit {
  min-height: 40px;
  padding: 0 15px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
}
.teamsDelete__cancel {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
}
.teamsDelete__submit {
  border: 1px solid #be123c;
  background: #be123c;
  color: #fff;
}
.teamsDelete__submit:disabled {
  border-color: #e2e8f0;
  background: #e2e8f0;
  color: #94a3b8;
}
.teamsPage__tableCard {
  overflow: hidden;
  margin: 0;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));
}
.teamsPage__tableScroll {
  overflow-x: auto;
}
.teamsPage__table {
  width: 100%;
  min-width: 850px;
  border-collapse: collapse;
}
.teamsPage__table th {
  height: 44px;
  padding: 0 14px;
  border-bottom: 1px solid #dbe3ec;
  background: #f8fafc;
  color: #69778a;
  font-size: 11px;
  font-weight: 750;
  letter-spacing: 0.045em;
  text-align: left;
  text-transform: uppercase;
}
.teamsPage__table th button {
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
}
.teamsPage__table td {
  height: 56px;
  padding: 8px 14px;
  border-bottom: 1px solid #e8edf2;
  font-size: 13px;
}
.teamsPage__table tbody tr {
  cursor: pointer;
}
.teamsPage__table tbody tr:hover,
.teamsPage__table tbody tr.is-selected {
  background: #f4f9fc;
}
.teamsPage__table tbody tr.is-house {
  box-shadow: inset 3px 0 #7b5bd6;
}
.teamsPage__check {
  width: 46px;
  text-align: center !important;
}
.teamsPage__check input {
  width: 16px;
  height: 16px;
  accent-color: #227ebd;
}
.teamsPage__teamCell {
  display: flex;
  align-items: center;
  gap: 11px;
}
.teamsPage__teamCell > span {
  display: flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #eaf4fb;
  color: #227ebd;
  font-size: 17px;
}
.teamsPage__teamCell > span.is-house {
  background: #f1edff;
  color: #7454bd;
}
.teamsPage__kitThumbnailSvg {
  display: block;
  width: 34px;
  height: 34px;
}
.teamsPage__teamCell > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}
.teamsPage__teamCell strong {
  color: #142033;
  font-size: 13px;
}
.teamsPage__teamCell small {
  max-width: 340px;
  overflow: hidden;
  color: #69778a;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.teamsPage__houseBadge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 4px 9px;
  border-radius: 999px;
  background: #f1edff;
  color: #6345a7;
  font-size: 11px;
  font-weight: 750;
}
.teamsPage__houseBadge i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #7b5bd6;
}
.teamsPage__muted {
  color: #94a3b8;
}
.teamsPage__empty {
  padding: 0 !important;
  color: #69778a;
  text-align: center;
}
.teamsPage__empty > div {
  display: flex;
  min-height: 260px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 28px;
}
.teamsPage__empty > div > span {
  display: inline-flex;
  width: 46px;
  height: 46px;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  border-radius: 12px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-500, #227ebd);
}
.teamsPage__empty strong {
  color: var(--text-strong, #0f172a);
  font-size: 15px;
  font-weight: 750;
}
.teamsPage__empty p {
  max-width: 420px;
  margin: 5px 0 16px;
  color: var(--text-muted, #64748b);
  font-size: 12.5px;
  line-height: 1.45;
}
.teamsPage__pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  min-height: 58px;
  margin: 0;
  padding: 10px 16px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}
.teamsPage__pagination > span {
  margin-right: auto;
  color: #69778a;
  font-size: 12px;
}
.teamsPage__pagination button {
  min-width: 36px;
  height: 36px;
  padding: 0 10px;
  border: 1px solid #d3dce6;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 12px;
}
.teamsPage__pagination button.is-active {
  border-color: #227ebd;
  background: #227ebd;
  color: #fff;
}
.teamsPage__pagination button:disabled {
  border-color: var(--border-subtle, #e2e8f0);
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-subtle, #94a3b8);
  cursor: not-allowed;
}
.teamsPage__pagination i {
  padding: 0 4px;
  color: #94a3b8;
}
.teamFormModal {
  max-width: 760px !important;
}
.teamsPage__seasonBadge {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 3px 9px;
  border: 1px solid #d6e3ef;
  border-radius: 999px;
  background: #f3f8fc;
  color: #315a78;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}
@media (max-width: 1217px) {
  .teamsPage__header {
    width: 100vw;
    margin-left: -12px;
    padding-right: 28px;
  }
}
@media (max-width: 760px) {
  .teamsPage__list {
    padding-bottom: 24px;
  }
  .teamsPage__header {
    width: 100vw;
    min-height: 64px;
    gap: 12px;
    margin-bottom: 14px;
    padding: 0 16px;
  }
  .teamsPage__toolbar {
    align-items: stretch;
    flex-direction: column;
    padding: 12px;
  }
  .teamsPage__search {
    width: auto;
  }
  .teamsPage__filters {
    top: 0;
    width: 100vw;
    max-width: none;
    align-items: stretch;
    flex-direction: column;
  }
  .teamsPage__filters > .teamsPage__filtersActions {
    width: 100vw;
    max-width: none;
  }
  .teamsPage__selection {
    align-items: flex-start;
    flex-direction: column;
  }
  .teamsPage__selection > div {
    flex-wrap: wrap;
    margin-left: 0;
  }
  .teamsPage__pagination > span {
    display: none;
  }
}
.teamsPage__seasonNav {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 16px;
}
.teamsPage__seasonNav button {
  padding: 9px 14px;
  border: 1px solid #d7dee7;
  border-radius: 20px;
  background: #fff;
}
.teamsPage__seasonNav button.is-active {
  color: #fff;
  border-color: #2f80ed;
  background: #2f80ed;
}
.teamsPage__seasonNav select {
  min-height: 38px;
  padding: 0 10px;
  border: 1px solid #d7dee7;
  border-radius: 8px;
  background: #fff;
}
.teamsPage__headerActions {
  display: flex;
  align-items: center;
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/TeamsAndEvents/Teams/SchoolTeams.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,cAAc;EACd,8FAA8F;AAChG;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,0BAA0B;EAC1B,sBAAsB;EACtB,sDAAsD;EACtD,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,SAAS;EACT,kCAAkC;EAClC,0GAA0G;EAC1G,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yGAAyG;AAC3G;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;AACA;;EAEE,aAAa;EACb,8CAA8C;AAChD;AACA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,WAAW;AACb;AACA;EACE,mCAAmC;EACnC,8CAA8C;AAChD;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,sDAAsD;EACtD,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iCAAiC;EACjC,YAAY;EACZ,gDAAgD;EAChD,oCAAoC;EACpC,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;AACA;EACE,0CAA0C;EAC1C,mEAAmE;AACrE;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,QAAQ;EACR,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;AACA;;;;EAIE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,8MAA8M;EAC9M,sNAAsN;AACxN;AACA;EACE,gRAAgR;EAChR,wRAAwR;AAC1R;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,QAAQ;EACR,SAAS;EACT,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,4CAA4C;EAC5C,UAAU;EACV,8CAA8C;AAChD;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,QAAQ;EACR,OAAO;EACP,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;EACb,eAAe;EACf,cAAc;EACd,UAAU;EACV,eAAe;EACf,sGAAsG;AACxG;AACA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,gCAAgC;AAClC;AACA;;EAEE,UAAU;AACZ;AACA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,SAAS;EACT,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,QAAQ;EACR,aAAa;EACb,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,+CAA+C;EAC/C,cAAc;EACd,8FAA8F;AAChG;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,OAAO;EACP,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,UAAU;EACV,QAAQ;EACR,SAAS;EACT,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,iCAAiC;AACnC;AACA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,sDAAsD;AACxD;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,OAAO;EACP,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,mEAAmE;AACrE;AACA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,8DAA8D;AAChE;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,mDAAmD;EACnD,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,MAAM;IACN,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX","sourcesContent":[".teamsScreen {\n  width: 100%;\n  min-width: 0;\n}\n.teamsPage__list {\n  width: 100%;\n  min-height: 100%;\n  margin: 0;\n  padding-bottom: 32px;\n  color: #334155;\n  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);\n}\n.teamsPage__header {\n  display: flex;\n  width: calc(100% + 48px);\n  min-height: 70px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  margin: -20px 0 18px -24px;\n  padding: 0 72px 0 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n.teamsPage__headerTitle {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 10px;\n}\n.teamsPage__header h1 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', var(--font-body, 'Public Sans', system-ui, sans-serif));\n  font-size: 22px;\n  font-weight: 800;\n  line-height: 1.1;\n  letter-spacing: -0.015em;\n}\n.teamsPage__headerTitle > span {\n  display: inline-flex;\n  min-width: 24px;\n  height: 22px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 11.5px;\n  font-weight: 800;\n}\n.teamsBtn {\n  display: inline-flex;\n  min-height: 40px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 14px;\n  border: 1px solid #cbd5e1;\n  border-radius: 9px;\n  background: #fff;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: border-color 0.14s ease, background-color 0.14s ease, color 0.14s ease, box-shadow 0.14s ease;\n}\n.teamsBtn--primary {\n  border-color: #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n.teamsBtn--primary:hover:not(:disabled) {\n  border-color: var(--blue-600, #1a6da3);\n  background: var(--blue-600, #1a6da3);\n}\n.teamsBtn:focus-visible,\n.teamsPage__list button:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.16);\n}\n.teamsBtn--danger {\n  border-color: transparent;\n  background: var(--red-500, #da4453);\n  color: #fff;\n}\n.teamsBtn--danger:hover:not(:disabled) {\n  background: var(--red-600, #c4313f);\n  box-shadow: 0 4px 12px rgba(218, 68, 83, 0.28);\n}\n.teamsBtn.is-active {\n  border-color: #227ebd;\n  background: #eef7fd;\n  color: #155d8c;\n}\n.teamsPage__toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 64px;\n  padding: 11px 16px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n.teamsPage__search {\n  position: relative;\n  display: block;\n  width: min(340px, 100%);\n  margin-bottom: 0;\n}\n.teamsPage__search input {\n  width: 100%;\n  height: var(--control-h-md, 40px);\n  min-width: 0;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  outline: none;\n  background: var(--surface-card, #fff);\n  color: var(--text-strong, #0f172a);\n  padding: 0 38px 0 12px;\n  font-size: var(--text-md, 14px);\n  box-shadow: none;\n}\n.teamsPage__search > button {\n  position: absolute;\n  top: 50%;\n  right: 7px;\n  display: inline-flex;\n  width: 28px;\n  height: 28px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  font: inherit;\n  font-size: 18px;\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n.teamsPage__search > button:hover {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n}\n.teamsPage__search input:focus {\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));\n}\n.teamsPage__columns {\n  position: relative;\n  display: flex;\n}\n.teamsPage__filterBtn,\n.teamsPage__columnsBtn {\n  position: relative;\n  display: inline-flex;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #334155;\n  cursor: pointer;\n}\n.teamsPage__filterBtn {\n  width: auto;\n  gap: 8px;\n  padding: 0 12px;\n  font-size: 13px;\n  font-weight: 700;\n}\n.teamsPage__columnsBtn {\n  gap: 8px;\n  padding: 0 12px 0 11px;\n  font-size: 13px;\n  font-weight: 700;\n}\n.teamsPage__filterBtn:hover,\n.teamsPage__filterBtn.is-active,\n.teamsPage__columnsBtn:hover,\n.teamsPage__columnsBtn.is-active {\n  border-color: #6fb1df;\n  background: #eef7fd;\n  color: #155d8c;\n}\n.teamsPage__toolbarIcon {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n  background: currentColor;\n  mask-position: center;\n  mask-repeat: no-repeat;\n  mask-size: 16px 16px;\n  -webkit-mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-size: 16px 16px;\n}\n.teamsPage__toolbarIcon--filter {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E\");\n}\n.teamsPage__toolbarIcon--columns {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='5' width='16' height='14' rx='2' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='M9 5v14M15 5v14' stroke='black' stroke-width='2'/%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='5' width='16' height='14' rx='2' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='M9 5v14M15 5v14' stroke='black' stroke-width='2'/%3E%3C/svg%3E\");\n}\n.teamsPage__filterDot {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  width: 7px;\n  height: 7px;\n  border: 1.5px solid #fff;\n  border-radius: 50%;\n  background: #f08c1a;\n}\n.teamsPage__filterBadge {\n  display: inline-flex;\n  min-width: 20px;\n  height: 20px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: #227ebd;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 800;\n}\n.teamsPage__columnsBadge {\n  display: inline-flex;\n  min-width: 18px;\n  height: 18px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 5px;\n  border-radius: 999px;\n  background: #eef6fc;\n  color: #155d8c;\n  font-size: 11px;\n}\n.teamsPage__columnsMenu {\n  position: absolute;\n  z-index: 20;\n  top: 46px;\n  right: 0;\n  display: grid;\n  width: 190px;\n  gap: 10px;\n  padding: 14px;\n  border: 1px solid #dbe3ec;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.14);\n}\n.teamsPage__columnsMenu strong {\n  color: #142033;\n  font-size: 13px;\n}\n.teamsPage__columnsMenu label {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  color: #475569;\n  font-size: 13px;\n}\n.teamsPage__filters {\n  position: fixed;\n  z-index: 1050;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  width: 360px;\n  max-width: calc(100vw - 20px);\n  flex-direction: column;\n  align-items: stretch;\n  gap: 16px;\n  padding: 18px 18px 86px;\n  overflow-y: auto;\n  border: 0;\n  border-left: 1px solid #d9e2ec;\n  border-radius: 0;\n  background: #fff;\n  box-shadow: -12px 0 34px rgba(15, 23, 42, 0.14);\n}\n.teamsPage__filters label {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 6px;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 700;\n}\n.teamsPage__filters select {\n  height: 40px;\n  padding: 7px;\n  border: 1px solid #cbd5e1;\n  border-radius: 9px;\n  background: #fff;\n  color: #334155;\n}\n.teamsPage__sportFilterControl {\n  position: relative;\n}\n.teamsPage__sportFilterControl > input {\n  box-sizing: border-box;\n  width: 100%;\n  height: 40px;\n  padding: 0 38px 0 11px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 9px;\n  background: #fff;\n  color: var(--text-body, #334155);\n  font: inherit;\n  font-size: 13px;\n  font-weight: 500;\n}\n.teamsPage__sportFilterControl > input:focus {\n  border-color: var(--action-primary, #227ebd);\n  outline: 0;\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.13);\n}\n.teamsPage__sportFilterControl > button {\n  position: absolute;\n  z-index: 2;\n  top: 5px;\n  right: 5px;\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n}\n.teamsPage__sportFilterControl > button:hover {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n}\n.teamsPage__sportFilterOptions {\n  position: absolute;\n  z-index: 6;\n  top: calc(100% + 5px);\n  right: 0;\n  left: 0;\n  display: grid;\n  max-height: 224px;\n  padding: 5px;\n  overflow-y: auto;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 9px;\n  background: #fff;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.14);\n}\n.teamsPage__sportFilterOptions > button {\n  padding: 9px 10px;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--text-body, #334155);\n  font: inherit;\n  font-size: 13px;\n  text-align: left;\n  cursor: pointer;\n}\n.teamsPage__sportFilterOptions > button:hover,\n.teamsPage__sportFilterOptions > button[aria-selected='true'] {\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n.teamsPage__sportFilterOptions > span {\n  padding: 10px;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  font-weight: 500;\n}\n.teamsPage__filtersHeader {\n  display: flex;\n  min-height: 34px;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e6ebf1;\n}\n.teamsPage__filtersHeader > div {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n.teamsPage__filtersHeader strong {\n  color: #172b4d;\n  font-size: 16px;\n  font-weight: 800;\n}\n.teamsPage__filtersHeader span {\n  color: #64748b;\n  font-size: 12px;\n}\n.teamsPage__filtersHeader > button {\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: #667085;\n  font-size: 22px;\n  cursor: pointer;\n}\n.teamsPage__squad {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #475569;\n}\n.teamsPage__more {\n  width: 34px;\n  height: 34px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-subtle, #94a3b8);\n  font: inherit;\n  font-size: 23px;\n  line-height: 1;\n  opacity: 0;\n  cursor: pointer;\n  transition: opacity 0.14s ease, border-color 0.14s ease, background-color 0.14s ease, color 0.14s ease;\n}\n.teamsPage__more:hover {\n  border-color: #dbe3ec;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-body, #334155);\n}\n.teamsPage__table tbody tr:hover .teamsPage__more,\n.teamsPage__more:focus-visible {\n  opacity: 1;\n}\n.teamsDrawer__scrim {\n  position: fixed;\n  z-index: 1090;\n  inset: 0;\n  border: 0;\n  background: rgba(15, 23, 42, 0.35);\n}\n.teamsDrawer {\n  position: fixed;\n  z-index: 1100;\n  top: 0;\n  right: 0;\n  display: flex;\n  width: min(480px, 100vw);\n  height: 100vh;\n  flex-direction: column;\n  background: #fff;\n  box-shadow: -18px 0 48px rgba(15, 23, 42, 0.18);\n  color: #334155;\n  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);\n}\n.teamsDrawer__head {\n  display: flex;\n  align-items: center;\n  gap: 13px;\n  padding: 22px 20px 18px;\n  border-bottom: 1px solid #e5eaf0;\n}\n.teamsDrawer__lead {\n  display: flex;\n  width: 46px;\n  height: 46px;\n  flex: 0 0 46px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  background: #eaf4fb;\n  color: #227ebd;\n  font-size: 21px;\n}\n.teamsDrawer__head > div {\n  min-width: 0;\n}\n.teamsDrawer__head h2 {\n  margin: 0;\n  overflow: hidden;\n  color: #142033;\n  font-size: 19px;\n  font-weight: 800;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.teamsDrawer__head p {\n  margin: 4px 0 0;\n  color: #69778a;\n  font-size: 12px;\n}\n.teamsDrawer__close {\n  width: 36px;\n  height: 36px;\n  margin-left: auto;\n  border: 0;\n  border-radius: 9px;\n  background: #f1f5f9;\n  color: #526174;\n  font-size: 23px;\n}\n.teamsDrawer__tabs {\n  display: flex;\n  padding: 0 20px;\n  border-bottom: 1px solid #e5eaf0;\n}\n.teamsDrawer__tabs button {\n  min-height: 46px;\n  padding: 0 13px;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n  color: #69778a;\n  font-family: inherit;\n  font-size: 13.5px;\n  font-weight: 650;\n}\n.teamsDrawer__tabs button.is-active {\n  border-bottom-color: #227ebd;\n  color: #155d8c;\n}\n.teamsDrawer__tabs span {\n  margin-left: 6px;\n  padding: 1px 6px;\n  border-radius: 999px;\n  background: #eef2f6;\n  font-size: 10px;\n}\n.teamsDrawer__body {\n  min-height: 0;\n  flex: 1;\n  overflow: auto;\n  padding: 20px;\n  font-family: inherit;\n  font-size: 13.5px;\n  line-height: 1.45;\n}\n.teamsDrawer__body .container-fluid {\n  padding: 0;\n}\n.teamsDrawer__foot {\n  display: flex;\n  justify-content: flex-end;\n  gap: 9px;\n  padding: 14px 20px;\n  border-top: 1px solid #e5eaf0;\n  background: #fff;\n}\n.teamsDrawer__foot button {\n  min-width: max-content;\n  font-family: inherit;\n  white-space: nowrap;\n}\n.teamsPage__filters > .teamsPage__filtersActions {\n  position: fixed;\n  z-index: 2;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  width: 360px;\n  max-width: calc(100vw - 20px);\n  justify-content: space-between;\n  gap: 8px;\n  margin: 0;\n  padding: 14px 18px;\n  border-top: 1px solid #e6ebf1;\n  background: #fff;\n}\n.teamsPage__filtersActions > div {\n  display: flex;\n  gap: 8px;\n}\n.teamsPage__filtersActions .is-clear {\n  border-color: transparent;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n}\n.teamsPage__filtersActions .is-clear:hover {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n}\n.teamsPage__filterChips {\n  display: flex;\n  min-height: 43px;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  padding: 8px 16px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n.teamsPage__filterChips > span {\n  display: inline-flex;\n  min-height: 27px;\n  align-items: center;\n  gap: 4px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: #eaf4fb;\n  color: #155d8c;\n  font-size: 12px;\n}\n.teamsPage__filterChips > span button,\n.teamsPage__filterChipsClear {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #1a6da3;\n  cursor: pointer;\n  font-weight: 700;\n}\n.teamsPage__filterChipsClear:hover {\n  text-decoration: underline;\n}\n.teamsPage__selection {\n  display: flex;\n  align-items: center;\n  margin: 0;\n  padding: 10px 16px;\n  border-bottom: 1px solid #b9d9ee;\n  background: var(--blue-50, #eef6fc);\n  color: #155d8c;\n  font-size: 13px;\n  font-weight: 700;\n}\n.teamsPage__selection > div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  margin-left: 12px;\n}\n.teamsPage__clear {\n  margin-left: auto;\n  border: 0;\n  background: none;\n  color: #526174;\n  font-size: 12px;\n  text-decoration: underline;\n}\n.teamsDelete {\n  color: #334155;\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n.teamsDelete__alert {\n  display: flex;\n  gap: 14px;\n  padding: 16px;\n  border: 1px solid #fecdd3;\n  border-radius: 12px;\n  background: #fff1f2;\n}\n.teamsDelete__icon {\n  display: inline-flex;\n  width: 36px;\n  height: 36px;\n  flex: 0 0 36px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: #ffe4e6;\n  color: #be123c;\n  font-size: 20px;\n  font-weight: 800;\n}\n.teamsDelete h3 {\n  margin: 0 0 4px;\n  color: #881337;\n  font-size: 15px;\n  font-weight: 800;\n}\n.teamsDelete p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.5;\n}\n.teamsDelete__details {\n  padding: 16px 2px;\n}\n.teamsDelete__names {\n  margin-top: 8px !important;\n  color: #64748b;\n}\n.teamsDelete__confirm {\n  display: flex;\n  margin: 0;\n  flex-direction: column;\n  gap: 7px;\n  font-size: 13px;\n}\n.teamsDelete__confirm input {\n  height: 40px;\n  padding: 0 11px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  font: inherit;\n}\n.teamsDelete__confirm input:focus {\n  border-color: #6fb1df;\n  outline: 0;\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.12);\n}\n.teamsDelete__footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 20px;\n}\n.teamsDelete__cancel,\n.teamsDelete__submit {\n  min-height: 40px;\n  padding: 0 15px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n}\n.teamsDelete__cancel {\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #334155;\n}\n.teamsDelete__submit {\n  border: 1px solid #be123c;\n  background: #be123c;\n  color: #fff;\n}\n.teamsDelete__submit:disabled {\n  border-color: #e2e8f0;\n  background: #e2e8f0;\n  color: #94a3b8;\n}\n.teamsPage__tableCard {\n  overflow: hidden;\n  margin: 0;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));\n}\n.teamsPage__tableScroll {\n  overflow-x: auto;\n}\n.teamsPage__table {\n  width: 100%;\n  min-width: 850px;\n  border-collapse: collapse;\n}\n.teamsPage__table th {\n  height: 44px;\n  padding: 0 14px;\n  border-bottom: 1px solid #dbe3ec;\n  background: #f8fafc;\n  color: #69778a;\n  font-size: 11px;\n  font-weight: 750;\n  letter-spacing: 0.045em;\n  text-align: left;\n  text-transform: uppercase;\n}\n.teamsPage__table th button {\n  border: 0;\n  background: none;\n  color: inherit;\n  font: inherit;\n  letter-spacing: inherit;\n  text-transform: inherit;\n}\n.teamsPage__table td {\n  height: 56px;\n  padding: 8px 14px;\n  border-bottom: 1px solid #e8edf2;\n  font-size: 13px;\n}\n.teamsPage__table tbody tr {\n  cursor: pointer;\n}\n.teamsPage__table tbody tr:hover,\n.teamsPage__table tbody tr.is-selected {\n  background: #f4f9fc;\n}\n.teamsPage__table tbody tr.is-house {\n  box-shadow: inset 3px 0 #7b5bd6;\n}\n.teamsPage__check {\n  width: 46px;\n  text-align: center !important;\n}\n.teamsPage__check input {\n  width: 16px;\n  height: 16px;\n  accent-color: #227ebd;\n}\n.teamsPage__teamCell {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n}\n.teamsPage__teamCell > span {\n  display: flex;\n  width: 34px;\n  height: 34px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9px;\n  background: #eaf4fb;\n  color: #227ebd;\n  font-size: 17px;\n}\n.teamsPage__teamCell > span.is-house {\n  background: #f1edff;\n  color: #7454bd;\n}\n.teamsPage__kitThumbnailSvg {\n  display: block;\n  width: 34px;\n  height: 34px;\n}\n.teamsPage__teamCell > div {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 3px;\n}\n.teamsPage__teamCell strong {\n  color: #142033;\n  font-size: 13px;\n}\n.teamsPage__teamCell small {\n  max-width: 340px;\n  overflow: hidden;\n  color: #69778a;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.teamsPage__houseBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 4px 9px;\n  border-radius: 999px;\n  background: #f1edff;\n  color: #6345a7;\n  font-size: 11px;\n  font-weight: 750;\n}\n.teamsPage__houseBadge i {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #7b5bd6;\n}\n.teamsPage__muted {\n  color: #94a3b8;\n}\n.teamsPage__empty {\n  padding: 0 !important;\n  color: #69778a;\n  text-align: center;\n}\n.teamsPage__empty > div {\n  display: flex;\n  min-height: 260px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 28px;\n}\n.teamsPage__empty > div > span {\n  display: inline-flex;\n  width: 46px;\n  height: 46px;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 12px;\n  border-radius: 12px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-500, #227ebd);\n}\n.teamsPage__empty strong {\n  color: var(--text-strong, #0f172a);\n  font-size: 15px;\n  font-weight: 750;\n}\n.teamsPage__empty p {\n  max-width: 420px;\n  margin: 5px 0 16px;\n  color: var(--text-muted, #64748b);\n  font-size: 12.5px;\n  line-height: 1.45;\n}\n.teamsPage__pagination {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 6px;\n  min-height: 58px;\n  margin: 0;\n  padding: 10px 16px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n.teamsPage__pagination > span {\n  margin-right: auto;\n  color: #69778a;\n  font-size: 12px;\n}\n.teamsPage__pagination button {\n  min-width: 36px;\n  height: 36px;\n  padding: 0 10px;\n  border: 1px solid #d3dce6;\n  border-radius: 8px;\n  background: #fff;\n  color: #475569;\n  font-size: 12px;\n}\n.teamsPage__pagination button.is-active {\n  border-color: #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n.teamsPage__pagination button:disabled {\n  border-color: var(--border-subtle, #e2e8f0);\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-subtle, #94a3b8);\n  cursor: not-allowed;\n}\n.teamsPage__pagination i {\n  padding: 0 4px;\n  color: #94a3b8;\n}\n.teamFormModal {\n  max-width: 760px !important;\n}\n.teamsPage__seasonBadge {\n  display: inline-flex;\n  align-items: center;\n  min-height: 26px;\n  padding: 3px 9px;\n  border: 1px solid #d6e3ef;\n  border-radius: 999px;\n  background: #f3f8fc;\n  color: #315a78;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n@media (max-width: 1217px) {\n  .teamsPage__header {\n    width: 100vw;\n    margin-left: -12px;\n    padding-right: 28px;\n  }\n}\n@media (max-width: 760px) {\n  .teamsPage__list {\n    padding-bottom: 24px;\n  }\n  .teamsPage__header {\n    width: 100vw;\n    min-height: 64px;\n    gap: 12px;\n    margin-bottom: 14px;\n    padding: 0 16px;\n  }\n  .teamsPage__toolbar {\n    align-items: stretch;\n    flex-direction: column;\n    padding: 12px;\n  }\n  .teamsPage__search {\n    width: auto;\n  }\n  .teamsPage__filters {\n    top: 0;\n    width: 100vw;\n    max-width: none;\n    align-items: stretch;\n    flex-direction: column;\n  }\n  .teamsPage__filters > .teamsPage__filtersActions {\n    width: 100vw;\n    max-width: none;\n  }\n  .teamsPage__selection {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n  .teamsPage__selection > div {\n    flex-wrap: wrap;\n    margin-left: 0;\n  }\n  .teamsPage__pagination > span {\n    display: none;\n  }\n}\n.teamsPage__seasonNav {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 16px;\n}\n.teamsPage__seasonNav button {\n  padding: 9px 14px;\n  border: 1px solid #d7dee7;\n  border-radius: 20px;\n  background: #fff;\n}\n.teamsPage__seasonNav button.is-active {\n  color: #fff;\n  border-color: #2f80ed;\n  background: #2f80ed;\n}\n.teamsPage__seasonNav select {\n  min-height: 38px;\n  padding: 0 10px;\n  border: 1px solid #d7dee7;\n  border-radius: 8px;\n  background: #fff;\n}\n.teamsPage__headerActions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
